import Navigation from './Navigation';
import Header from './Header';
import UserHeader from './UserHeader';
import '../styles/layout/layout.css';
import { useEffect, useState } from 'react';

const Layout = ({ children }) => {
  const [userState, setUserState] = useState(null);

  useEffect(() => {
    const handleLogin = () => {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        const parsed = JSON.parse(storedUser);
        setUserState(parsed.state);
      } else {
        setUserState(null);
      }
    };

    handleLogin(); 
    window.addEventListener('login', handleLogin);

    return () => window.removeEventListener('login', handleLogin);
  }, []);

  // 관리자(R)인 경우
  if (userState === 'R') {
    return (
      <div className="main-layout">
        <Header />
        
        <div className="content-wrapper">
          <Navigation />
          
          <main className="main-content">
            {children || (
              <div className="default-content">
                <h1>메인</h1>
              </div>
            )}
          </main>
        </div>
      </div>
    );
  }

  // 일반 사용자(U)인 경우
  return (
    <div className="main-layout">
      <UserHeader />
      
      <main className="main-content">
        {children || (
          <div className="default-content">
            <h1>메인</h1>
          </div>
        )}
      </main>
    </div>
  );
};

export default Layout;